// Stable per-device id sent as X-Device-Fp on every request. The server binds a
// user to the first one it sees at login and queues an admin approval when a
// different one shows up.
//
// A browser has no hardware id, so this is a random UUID created once and kept
// in localStorage with a 1-year cookie as a backup (clearing one but not the
// other keeps the same id). Clearing ALL site data makes a new id — which is
// treated as a new device and needs approval again, by design.
const KEY = "tulsi_device_id";
const COOKIE = "tulsi_did";

function readCookie() {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${COOKIE}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch { return null; }
}

function writeCookie(v) {
  try {
    document.cookie = `${COOKIE}=${encodeURIComponent(v)}; max-age=${60 * 60 * 24 * 365}; path=/; SameSite=Lax`;
  } catch { /* cookies blocked */ }
}

function newId() {
  try {
    if (crypto?.randomUUID) return crypto.randomUUID();
  } catch { /* fall through */ }
  return "d-" + Date.now().toString(36) + "-" + Math.random().toString(36).slice(2, 12);
}

let cached = null;

export function getDeviceId() {
  if (cached) return cached;
  let id = null;
  try { id = localStorage.getItem(KEY); } catch { /* storage blocked */ }
  if (!id) id = readCookie();
  if (!id) id = newId();
  try { localStorage.setItem(KEY, id); } catch { /* storage blocked */ }
  writeCookie(id);
  cached = id;
  return id;
}
